import { useMatch, useParams } from 'react-router-dom'

import { NotFound } from '@factorialco/deprecated-design-system'
import { TasksValueObjectsTaskIdentifierEnum } from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

import { type ContractVersions } from 'modules/contracts/store/collections/contractVersions'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import { TaskIdentifier } from 'modules/tasks/lib/task'

import { TaskElementContent } from './TaskElementContent'
import { useTaskDetails } from './useTaskDetail'

interface Props {
  taskId: number
  back?: string
  identifier?: TasksValueObjectsTaskIdentifierEnum
  contractVersions: ContractVersions
  canEmployeeManageAnyEmployeeFolder: boolean
  loading: boolean
}

const TaskElement = ({
  taskId,
  identifier,
  back,
  contractVersions,
  canEmployeeManageAnyEmployeeFolder,
  loading: parentLoading,
}: Props) => {
  const { id: employeeId } = useParams()
  const { navigation } = useNavigation()
  const fromEployeePage = !!useMatch({
    path: employeeId
      ? navigation.employees.id.tasks.taskId.fullPath({ id: +employeeId, taskId: Number(taskId) })
      : '',
  })

  // Only single task can be seen from employee page, single tasks are task assigned to employee or created by employee
  const taskIdentifier = identifier || (fromEployeePage ? TaskIdentifier.Single : undefined)

  const { task, loading, canSeePersonalInfo, error, canEditPersonalInfo } = useTaskDetails({
    ids: [taskId],
    identifier: taskIdentifier,
  })

  if (!loading && !task)
    return (
      <NotFound
        title={i18n.t('errors.page_not_found.title')}
        description={i18n.t('errors.page_not_found.description')}
      />
    )

  const authorized = !!task

  const backLink = {
    href: back || navigation.tasks.fullPath(),
    label: '',
  }
  return (
    <ResponsivePage.Body
      variant="full"
      loading={loading || parentLoading}
      error={error}
      showHeader={false}
      authorized={authorized}
      backLink={backLink}
    >
      {task && (
        <TaskElementContent
          task={task}
          canSeePersonalInfo={canSeePersonalInfo}
          canEditPersonalInfo={canEditPersonalInfo}
          contractVersions={contractVersions}
          canEmployeeManageAnyEmployeeFolder={canEmployeeManageAnyEmployeeFolder}
        />
      )}
    </ResponsivePage.Body>
  )
}

export default observer(TaskElement)
